/**
 * Equalize Heights
 */
(function ($) {
    $.fn.equalizeHeights = function () {
        return this.css('min-height', 0).css('min-height', Math.max.apply(this, jQuery(this).map(function (i, e) {
            return jQuery(e).outerHeight()
        }).get()));
    }
})(jQuery);

/**
 * Service button click (SEO Feature)
 */
if (document.querySelector('.ce_service-button:not(.big)') !== null) {
    const serviceButtons = document.querySelectorAll('.ce_service-button:not(.big)');
    for (let serviceButton of serviceButtons) {
        serviceButton.addEventListener('click', (e) => {
            e.preventDefault();
            window.location.href = e.currentTarget.querySelector("a").getAttribute("href");
        });
    }
}

/**
 * Service buttons equalize
 */
jQuery(".row").each(function () {
    if (jQuery(window).width() > 1279) {
        jQuery(this).find('.ce_service-button .description .texts').equalizeHeights();
        jQuery(this).find('.ce_service-button').equalizeHeights();
    }
});
